module.exports = __webpack_public_path__ + "media/markers/anchor_blu-482148b1.svg";